var _excluded = ["children", "className", "id", "inversed"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import classNames from 'classnames';
import { AlertCircleIcon } from '../Icons/AlertCircleIcon';
import { t } from '../i18n';
import useId from '../utilities/useId';
/**
 * Inline errors are error messages that are paired directly with form fields.
 * They are built in to all form fields in the design system, but they can also
 * be used on their own to create custom fields.
 *
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/inline-error/).
 */
export function InlineError(_ref) {
  var children = _ref.children,
    className = _ref.className,
    id = _ref.id,
    inversed = _ref.inversed,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var classes = classNames('ds-c-inline-error', {
    'ds-c-inline-error--inverse': inversed
  }, className);
  var viewbox = '36 -12 186 186';
  return /*#__PURE__*/React.createElement("p", _extends({}, otherProps, {
    className: classes,
    id: useId('inline-error--', id),
    "aria-live": "assertive",
    "aria-atomic": "true"
  }), /*#__PURE__*/React.createElement(AlertCircleIcon, {
    viewBox: viewbox
  }), /*#__PURE__*/React.createElement("span", {
    className: "ds-u-visibility--screen-reader"
  }, "".concat(t('inlineError.prefix'), ": ")), children);
}
export default InlineError;